module.exports = __webpack_public_path__ + "media/new_ui/logo-43dd3988.svg";